/**
 * callTaskLabels.js — 업무/기능 배정 화면의 일일콜 관리 이름 (2026-09-24, 사용자 확정)
 *
 * 사용자 원문: "여기에서는 회사별로 메뉴명 + (회사명) 이렇게 보여줘야 하는거 아냐? 그래야 원하는 메뉴를 잘 배정하지"
 *   파인그룹(일일콜 켠 회사 3곳): '일일콜현황 관리 (통합)' / '일일콜현황 관리 (파인그룹)' / '… (DOT)' / '… (LNJ)'
 *   미팅링크(1곳):              '일일콜현황 관리' / 옛 제주 항목은 숨기지 않고 '일일콜현황 관리 (미팅링크)'
 *
 * 권한 이름표(permissions.label)는 사이트마다 한 줄뿐이라 테넌트별로 쓸 수 없다 → **보는 사람 기준으로 화면에서만** 바꾼다.
 *   코드·묶음·정렬은 그대로(묶음·정렬은 코드 기준 — itemGrouping.js). 회사 수를 모르면 서버 이름 그대로.
 *   회사별 항목(EXTERNAL_{C}_TM_CALL_MANAGEMENT = '… (DOT)')은 이미 회사 이름이 붙어 있어 건드리지 않는다.
 *
 * 2026-10-14 (통합 계획 3단계 7번, 사용자 결정 3-a): 회사 2곳 이상 테넌트는 A '(통합)' 칸을 없앴다. 그 뒤
 *   TM_CALL_MANAGEMENT 는 메뉴를 만들지 않고 상황판 일일콜 위젯·콜 관리 모드만 여는 열쇠라
 *   '일일콜 관리 권한(상황판·콜 수정)' 으로 보인다. 메뉴는 통합 메뉴 '*일일콜현황 관리 (통합)' 열쇠로 준다.
 */
import { callNamingState } from '../adminlayout/callMenuNaming';

const BASE = '일일콜현황 관리';
const MULTI_ALL_LABEL = '일일콜 관리 권한(상황판·콜 수정)';

/** 코드 하나의 표시 이름. null = 서버 이름 그대로. */
export function callTaskLabel(code, info) {
  const state = callNamingState(info);
  if (state === 'unknown') return null;
  if (code === 'TM_CALL_MANAGEMENT') return state === 'multi' ? MULTI_ALL_LABEL : BASE;
  if (code === 'TM_CALL_MANAGEMENT_JEJU') return info?.primaryName ? `${BASE} (${info.primaryName})` : null;
  return null;
}

/** 배정 현황 응답(taskOptions·itemSummaries)의 이름만 바꾼 복사본. 모르면 원본 그대로. */
export function relabelCallTasks(overview, info) {
  if (!overview || callNamingState(info) === 'unknown') return overview;
  const fix = (row) => {
    const label = callTaskLabel(row?.code, info);
    return label && label !== row.label ? { ...row, label } : row;
  };
  return {
    ...overview,
    taskOptions: Array.isArray(overview.taskOptions) ? overview.taskOptions.map(fix) : overview.taskOptions,
    itemSummaries: Array.isArray(overview.itemSummaries)
      ? overview.itemSummaries.map((row) => (row?.kind === 'task' ? fix(row) : row))
      : overview.itemSummaries,
  };
}
